import { BCard } from '../ui/generic';
import BDrawer from '../BDrawer';
import { useForm } from 'react-hook-form';
import BSelect from '../ui/form/BSelect';
import Single from './Single';
import { requiredField } from '../../utils';
import { IconCheck, IconLoader2, IconUpload, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../utils/AxiosInstance';
import { toast } from 'react-toastify';

const Add = ({ callback }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [isError, setIsError] = useState(false);
  const queryClient = useQueryClient();
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const typeWatch = watch('type');

  const handleAddFile = async (data) => {
    if (!data[`file${typeWatch}`]) return;
    const file = data[`file${typeWatch}`][0];
    const formData = new FormData();
    formData.append('document', file); // only one file here
    formData.append('type', typeWatch); // only one file here

    const response = await axiosInstance.post('/internal_api/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (!response.data.error) {
      setIsSuccess(true);
      queryClient.invalidateQueries(['documents']);
      callback();
    } else {
      setIsError(true);
      setMessageError(response.data.message);
    }
  };
  return (
    <form onChange={handleSubmit(handleAddFile)}>
      <BCard>
        <BCard.Header title={'Ajout de documents'} withTitle></BCard.Header>
        <BCard.Body>
          <BCard.Label>
            <BSelect
              label={'Type de document'}
              options={[
                { id: 'identityRecto', name: 'Carte identité recto' },
                { id: 'identityVerso', name: 'Carte identité verso' },
                { id: 'cv', name: 'CV' },
                { id: 'motivationLetter', name: 'Lettre de motivation' },
                { id: 'diplome', name: 'Diplome' },
                { id: 'autre', name: 'Autre document' },
              ]}
              {...register('type', { required: { value: true, message: requiredField } })}
            />
          </BCard.Label>
          {typeWatch && (
            <label
              htmlFor={`file${typeWatch}`}
              className="mx-auto flex h-fit w-full max-w-md cursor-pointer flex-col items-center justify-center rounded border-2 border-dashed border-slate-200 bg-white py-2 text-base text-slate-700"
            >
              {isSubmitting ? (
                <IconLoader2 className={`mb-3 w-11 animate-spin`} />
              ) : isSuccess ? (
                <IconCheck className={'mb-3 w-11 text-green-500'} />
              ) : (
                <IconUpload className={'mb-3 w-11'} />
              )}
              Déposez votre document
              <p className={'text-xs text-red-500'}>{messageError}</p>
              <input
                {...register(`file${typeWatch}`, { required: true })}
                type={'file'}
                id={`file${typeWatch}`}
                className="hidden"
              />
            </label>
          )}
        </BCard.Body>
      </BCard>
    </form>
  );
};

export default Add;
